import { createSelector } from 'reselect';
import { serviceProviderAdditionalFields, serviceProviderIdWithFallback, serviceProvider } from './serviceProviderSelectors.js';
import { userServiceProviders } from './authSelectors.js';
import getDefaultUserRoute from '../lib/getDefaultUserRoute.js';
import { mobile } from './filterSelectors.js';
import { notificationFolderId, pathname } from 'selectors/querySelectors.js';

const stableObject = {};
const stableArray = [];

export const app = (state) => state.app;
export const todoStatuses = createSelector(app, (app) => app.todo_statuses);
export const todoTypes = createSelector(app, (app) => app.todo_types);
export const platforms = createSelector(app, (app) => app.platforms);
export const permissions = createSelector(app, (app) => app.permissions);
export const utmMediumByValue = (value) => createSelector(app, (app) => (app.utm_mediums.find(n => n.value === value) || stableObject).name);
export const utmMediumValueByName = (name) => createSelector(app, (app) => (app.utm_mediums.find(n => n.name === name) || stableObject).value);
export const serviceProviders = createSelector(app, (app) => app.serviceProviders);
export const pipelineLeadStatuses = createSelector(app, (app) => (app || {}).pipeline_lead_statuses || stableArray);

export const defaultUserRoute = createSelector(serviceProviderIdWithFallback, userServiceProviders, serviceProvider, mobile, (serviceProviderId, userServiceProviders, serviceProviders, serviceProvider, mobile) => {
  return (serviceProviders || []).length === 1 || mobile ? getDefaultUserRoute(serviceProviderId, userServiceProviders, serviceProvider) : `/dashboard/service-providers`;
});

export const embeddedNotificationSlider = createSelector(pathname, serviceProviderAdditionalFields, (path, fields) => {
  const embeds = ((fields || stableObject).notificationSlider || stableObject).embed || stableArray;
  return !path.includes('/settings') && !path.includes('/reports/') && !!embeds.find((n) => path.includes(`/${n}`));
});

export const notificationSliderOpen = createSelector(notificationFolderId, pathname, embeddedNotificationSlider, (notificationFolderId, pathname, embed) => {
  return !!notificationFolderId || embed;
});
